import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import RichText from './richtext';

class AdditionalContent extends PureComponent {
  static propTypes = {
    additional: PropTypes.array.isRequired,
    expanded: PropTypes.bool.isRequired,
    session: PropTypes.object.isRequired,
  };

  _renderItems() {
    const { additional, session } = this.props;
    return additional.map(({ key }) => {
      const title = session[key];
      if (key === 'description') return null;
      return (
        <li className="list-group-item col-md-4" key={`${key}-${session.id}`}>
          {key}: {title}
        </li>
      );
    });
  }

  render() {
    const { session, expanded } = this.props;
    if (!expanded) return null;
    return (
      <div className={classNames(['additional', { active: expanded }])}>
        <ul className="list-group">{this._renderItems()}</ul>
        <div className="description">
          <RichText content={session.description} />
        </div>
      </div>
    );
  }
}

export default AdditionalContent;
